import { render } from "./AddTir.vue?vue&type=template&id=34801680"
import script from "./AddTir.vue?vue&type=script&lang=js"
export * from "./AddTir.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__